import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeroPanelComponent } from './hero-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [HeroPanelComponent],
  exports: [HeroPanelComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
})
export class HeroPanelModule { }
